import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/imovel-render-1.svg'


const _withScopeId = n => (_pushScopeId("data-v-77f72c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row justify-content-center pt-5 gx-5",
  ref: "sectionMain",
  id: "section-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("header", { class: "col-lg-12 col-md-12 col-sm-12 d-lg-flex d-md-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Análise financeira")
  ])
], -1))
const _hoisted_3 = { class: "row section-content mt-3 mb-5 d-lg-flex d-md-block justify-content-around" }
const _hoisted_4 = { class: "col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 justify-content-between d-flex flex-column gap15" }
const _hoisted_5 = {
  key: 0,
  class: "info-card-box lc-bg-purple"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Retorno de Investimento", -1))
const _hoisted_7 = { class: "row gap15" }
const _hoisted_8 = { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, "Lucro líquido", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "R$ ", -1))
const _hoisted_12 = { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, [
  /*#__PURE__*/_createTextVNode("ROI "),
  /*#__PURE__*/_createElementVNode("span", { class: "cgray" }, "(VGV Líquido – Investimento Previsto)")
], -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-up-fill" }, null, -1))
const _hoisted_16 = { class: "col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 justify-content-between d-flex flex-column gap15" }
const _hoisted_17 = { class: "info-card-box mobile-top" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "VGV", -1))
const _hoisted_19 = { class: "row gap28" }
const _hoisted_20 = { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description nowrap cgray" }, "Valor do m² x Área privativa", -1))
const _hoisted_22 = { class: "value nowrap" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "R$ ", -1))
const _hoisted_24 = { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }
const _hoisted_25 = { class: "description" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_28 = { class: "info-card-box-2 d-flex flex-column justify-content-between" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "VGV Líquido", -1))
const _hoisted_30 = { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between align-items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description cgray" }, "VGV após Permuta", -1))
const _hoisted_32 = { class: "value" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "R$ ", -1))
const _hoisted_34 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_35 = { class: "info-card-box-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "nowrap" }, "Custos Diretos de Obra", -1))
const _hoisted_37 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_38 = {
  class: "d-flex flex-column justify-content-start",
  style: {}
}
const _hoisted_39 = { class: "description2" }
const _hoisted_40 = { style: {"margin-left":"-25px"} }
const _hoisted_41 = { class: "d-flex flex-column justify-content-between align-items-end" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs12 nowrap cgray" }, "Área Construída x CUB", -1))
const _hoisted_43 = { style: {"width":"100%"} }
const _hoisted_44 = { class: "value nowrap" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "R$ ", -1))
const _hoisted_46 = { class: "d-lg-flex d-md-block justify-content-between align-items-center gap15" }
const _hoisted_47 = {
  class: "info-card-box lc-bg-purple",
  style: {"width":"100%"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "nowrap" }, "Investimento previsto", -1))
const _hoisted_49 = { class: "value" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "R$ ", -1))
const _hoisted_51 = {
  class: "info-card-box lc-bg-purple",
  style: {"width":"100%"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "nowrap" }, "Margem líquida", -1))
const _hoisted_53 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description cgray" }, "Lucro líquido ÷ VGV", -1))
const _hoisted_55 = { class: "value" }
const _hoisted_56 = {
  key: 0,
  class: "info-card-box lc-bg-purple"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Retorno de Investimento", -1))
const _hoisted_58 = { class: "row gap15" }
const _hoisted_59 = { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, "Lucro líquido", -1))
const _hoisted_61 = { class: "value" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "R$ ", -1))
const _hoisted_63 = { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "description",
  style: {"white-space":"wrap"}
}, [
  /*#__PURE__*/_createTextVNode("ROI "),
  /*#__PURE__*/_createElementVNode("span", { class: "cgray" }, "(VGV Líquido – Investimento Previsto)")
], -1))
const _hoisted_65 = { class: "value nowrap" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-up-fill" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardCalc = _resolveComponent("CardCalc")!
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CardCalc, {
          title: "Dados do Imóvel",
          items: _ctx.imovelDataItems,
          areaPrivativaValue: _ctx.inputAreaPrivativaValue,
          areaConstruidaValue: _ctx.inputAreaTotalConstruidaValue,
          isBlockedOpportunity: _ctx.isBlockedOpportunity,
          onInputValueUpdated: _ctx.handleInputValueUpdated
        }, null, 8, ["items", "areaPrivativaValue", "areaConstruidaValue", "isBlockedOpportunity", "onInputValueUpdated"]),
        _createElementVNode("img", {
          class: _normalizeClass(["summary-financial-analysis-section-column1-map", { blurred: _ctx.isBlockedOpportunity }]),
          src: _imports_0,
          alt: "map"
        }, null, 2),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", {
                      class: _normalizeClass(["value1", { blurred: _ctx.isBlockedOpportunity }])
                    }, _toDisplayString(_ctx.formatNumber(_ctx.lucroLiquido, 0)), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", {
                      class: _normalizeClass(["value2", { blurred: _ctx.isBlockedOpportunity }])
                    }, _toDisplayString(_ctx.formatROI(_ctx.roi)), 3)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", {
                  class: _normalizeClass(["value1", { blurred: _ctx.isBlockedOpportunity }])
                }, _toDisplayString(_ctx.formatNumber(_ctx.vgvValue, 0)), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, [
                _createTextVNode(" Valor do m²: "),
                _createElementVNode("u", {
                  style: {"color":"#4f3c88"},
                  class: _normalizeClass({ blurred: _ctx.isBlockedOpportunity })
                }, " R$ " + _toDisplayString(_ctx.formatNumber(_ctx.valorMetroQuadradoSlider, 0)), 3)
              ]),
              _createVNode(_component_Slider, {
                label: "m²",
                onSliderValue: _cache[0] || (_cache[0] = newValue => _ctx.handleSliderChange(newValue, 'sectionVGV')),
                min: 0,
                max: 50000,
                value: _ctx.valorMetroQuadradoSlider,
                class: _normalizeClass({ blurred: _ctx.isBlockedOpportunity })
              }, null, 8, ["value", "class"])
            ])
          ])
        ]),
        _createVNode(_component_CardCalc, {
          title: "Custos do Terreno",
          items: _ctx.landCoastItems,
          "show-input": true,
          "is-ground-coasts": true,
          onInputValueUpdated: _ctx.handleInputValueUpdated,
          onSliderValue: _cache[1] || (_cache[1] = newValue => _ctx.handleSliderChange(newValue, 'sectionGroundCoasts')),
          step: 1,
          value: _ctx.completeOpportunity.valor_permuta,
          isBlockedOpportunity: _ctx.isBlockedOpportunity
        }, null, 8, ["items", "onInputValueUpdated", "value", "isBlockedOpportunity"]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("span", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("span", {
                    class: _normalizeClass(["value1", { blurred: _ctx.isBlockedOpportunity }])
                  }, _toDisplayString(_ctx.formatNumber(_ctx.vgvLiquidoValue, 0)), 3)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_39, " R$ " + _toDisplayString(_ctx.formatNumber(_ctx.custosObraSlider, 0)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_Slider, {
                        "scale-size": "small",
                        "show-as-number": false,
                        "show-as-percentual": false,
                        onSliderValue: _cache[2] || (_cache[2] = newValue => _ctx.handleSliderChange(newValue, 'custosObraSection')),
                        min: 0,
                        max: 5000,
                        value: _ctx.custosObraSlider,
                        label: 'CUB',
                        class: _normalizeClass({ blurred: _ctx.isBlockedOpportunity })
                      }, null, 8, ["value", "class"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("span", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("span", {
                        class: _normalizeClass(["value1", { blurred: _ctx.isBlockedOpportunity }])
                      }, _toDisplayString(_ctx.formatNumber(_ctx.custosObraValue, 0)), 3)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_CardCalc, {
          title: "Custos Indiretos",
          items: _ctx.indirectCoasts,
          onSliderValueProject: _cache[3] || (_cache[3] = newValue => _ctx.handleIndirectCoastsChange(newValue, 0)),
          onSliderValueMarketing: _cache[4] || (_cache[4] = newValue => _ctx.handleIndirectCoastsChange(newValue, 1)),
          onSliderValueImpostos: _cache[5] || (_cache[5] = newValue => _ctx.handleIndirectCoastsChange(newValue, 2)),
          onSliderValueComissoes: _cache[6] || (_cache[6] = newValue => _ctx.handleIndirectCoastsChange(newValue, 3)),
          "show-slider": false,
          step: 1,
          "scale-size": "small",
          "show-as-number": false,
          "show-as-percentual": false,
          "is-indirect-coasts": true,
          "is-blocked-opportunity": _ctx.isBlockedOpportunity,
          comissoes: _ctx.comissoes_final,
          impostos: _ctx.impostos_final,
          marketing: _ctx.marketing_final,
          projeto: _ctx.projeto_final,
          valueList: _ctx.valueList
        }, null, 8, ["items", "is-blocked-opportunity", "comissoes", "impostos", "marketing", "projeto", "valueList"]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("span", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("span", {
                class: _normalizeClass(["value1", { blurred: _ctx.isBlockedOpportunity }])
              }, _toDisplayString(_ctx.formatNumber(_ctx.investimentoPrevisto, 0)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("span", _hoisted_55, [
                _createElementVNode("span", {
                  class: _normalizeClass(["value1", { blurred: _ctx.isBlockedOpportunity }])
                }, _toDisplayString(_ctx.formatNumber(_ctx.margemLiquida * 100, 1) + "%"), 3)
              ])
            ])
          ])
        ]),
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("span", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("span", {
                      class: _normalizeClass(["value1", { blurred: _ctx.isBlockedOpportunity }])
                    }, _toDisplayString(_ctx.formatNumber(_ctx.lucroLiquido, 0)), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("span", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("span", {
                      class: _normalizeClass(["value2", { blurred: _ctx.isBlockedOpportunity }])
                    }, _toDisplayString(_ctx.formatROI(_ctx.roi)), 3)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}